import { renderToStaticMarkup } from "react-dom/server";
import PlanDocument from "./PlanDocument";
import { DailyPlan } from "./plan";

// These rules belong only to the isolated print document, never to the application.
const printStyles = `
@page { size: A4 landscape; margin: 8mm; }
body { margin: 0; font-family: "Noto Sans", Arial, sans-serif; font-size: 9px; color: #111; }
h2 { font-size: 16px; margin: 0; } h3 { font-size: 12px; margin: 14px 0 8px; }
.plan-heading { display: flex; gap: 16px; align-items: baseline; margin-bottom: 12px; }
.delivery-plan-table { width: 100%; border-collapse: collapse; table-layout: fixed; }
th, td { border: 1px solid #777; padding: 4px; vertical-align: top; text-align: left; overflow-wrap: break-word; }
thead { display: table-header-group; } thead th { background: #f3f4f6; text-align: center; }
tr { break-inside: avoid; } .plan-vehicle-column { width: 8%; }
.plan-quantity-column { width: 5%; } .plan-item-column { width: 13.4%; }
.plan-quantity { text-align: right; white-space: nowrap; font-variant-numeric: tabular-nums; }
.plan-item { white-space: pre-wrap; line-height: 1.4; }
.plan-item-name, .plan-customer { font-weight: 600; }
.plan-order, .plan-note { margin-top: 3px; }
.plan-unassigned th:first-child { width: 8%; } .plan-unassigned th:nth-child(2) { width: 5%; }
.plan-totals { margin-top: 12px; display: flex; gap: 20px; }
.plan-other-totals > div { margin-top: 4px; }
`;
export const createPlanPrintHtml = (data: DailyPlan) =>
    `<!doctype html><html lang="vi"><head><meta charset="utf-8"><title>Lịch giao hàng</title><link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;600;700&amp;display=swap"><style>${printStyles}</style></head><body>${renderToStaticMarkup(<PlanDocument data={data} printable />)}</body></html>`;

export function printDailyPlan(data: DailyPlan): Promise<void> {
    return new Promise((resolve, reject) => {
        const frame = document.createElement("iframe");
        frame.title = "Bản in kế hoạch giao hàng";
        frame.setAttribute("aria-hidden", "true");
        frame.style.cssText = "position:fixed;left:-10000px;top:0;width:1120px;height:800px;border:0";
        const cleanup = () => frame.remove();
        const timeout = window.setTimeout(() => {
            cleanup();
            reject(new Error("Không tải được bản in"));
        }, 15000);
        frame.onload = async () => {
            const target = frame.contentWindow;
            if (!target) {
                clearTimeout(timeout);
                cleanup();
                reject(new Error("Không mở được bản in"));
                return;
            }
            try {
                await target.document.fonts?.ready;
                clearTimeout(timeout);
                target.addEventListener("afterprint", cleanup, { once: true });
                target.focus();
                target.print();
                // Keep the document until afterprint, including browsers with asynchronous print dialogs.
                resolve();
            } catch (error) {
                clearTimeout(timeout);
                cleanup();
                reject(error);
            }
        };
        frame.srcdoc = createPlanPrintHtml(data);
        document.body.appendChild(frame);
    });
}
